module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAS1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////+DmQsHAAAAGHRSTlMAf7/3RsMf51Pzt4/v4ZODT6kxx59vJwjF9eFAAAAAxElEQVRIx+3Vza7CIBBA4alA+Wtr9V71vP+TaiChjYmddKfGs4IM35KMfE/BGTaLbpZVR9A7SmuGYeo2yx5CAw7fi1I/4NolkkVtwrQzdDro4AeeCsnuAhcwVgfrYREqWGZVaGAZxRFvqtBBBn8+cLBF6OAfxqs8gBShghOMvRRQhQLO5X0FRTgF3E6plwbE/gUF1Cqo/cBrkEj7gE323f70xwHDpINMXC2UQV8ofrVQAvjcbTYNMO9fikuzi2xmXJCv6Q7geiECZFVrXwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloadlogo.png
// module id = 4Evx
// module chunks = 4